/**
 * What the project's setup (owner, 2026-11-03) still lacks, as the reason
 * `+ New`, Edit and Save are unavailable: the harness assigned and CI wired
 * are both needed (CI that doesn't validate, or no `.gitlab-ci.yml`, counts
 * as not wired), and CI wiring GitLab couldn't check blocks too (Save would
 * answer 503). An include the lint doesn't see ("named") doesn't block:
 * Sanctum can't tell, and the setup status says so. Withdraw is never
 * blocked. The backend enforces the same gate on Save (409 "setup
 * incomplete: …").
 */

import { isAxiosError } from 'axios';
import { panelErrorMessage } from './errors';
import type { CiWiring, PanelSetup } from '../types/projectPanel.types';

const CI_MISSING: Partial<Record<CiWiring, string>> = {
  not_wired: "this project's CI doesn't call Sanctum yet",
  invalid: "this project's CI configuration doesn't validate",
  missing: 'this project has no .gitlab-ci.yml',
};

export function setupBlockReason(setup: PanelSetup | null): string | null {
  if (setup === null) return null;
  const missing: string[] = [];
  if (!setup.harness_assigned) missing.push("the Sanctum agent harness isn't assigned");
  const ci = CI_MISSING[setup.ci];
  if (ci !== undefined) missing.push(ci);
  if (missing.length > 0) return `Finish setup first: ${missing.join('; ')}.`;
  if (setup.ci === 'unknown') return "Setup can't be checked right now; try again.";
  return null;
}

/**
 * Why "Add to .gitlab-ci.yml" failed: a 422's `{message, include_line}`
 * (the file is one to edit by hand) reads as its message; anything else as
 * `panelErrorMessage`.
 */
export function ciIncludeErrorMessage(error: unknown): string {
  if (isAxiosError(error) && error.response?.status === 422) {
    const data: unknown = error.response.data;
    const detail: unknown = data && typeof data === 'object' && 'detail' in data ? data.detail : null;
    if (detail && typeof detail === 'object' && 'message' in detail && typeof detail.message === 'string') {
      return detail.message;
    }
  }
  return panelErrorMessage(error);
}
